// The account menu (main_menu.dart _openAccountMenu), opened from the
// rail's logo and the phone Home header's avatar:
//   accountMenu.open(anchorEl)
// AccountMenu.vue (mounted once by AppShell) draws it at the anchor.
import { reactive } from "vue";

export const accountMenuState = reactive({ open: false, anchor: null, seq: 0 });

export const accountMenu = {
  open(anchorEl) {
    accountMenuState.anchor = anchorEl && anchorEl.$el ? anchorEl.$el : anchorEl || null;
    accountMenuState.seq += 1;
    accountMenuState.open = true;
  },
  close() {
    accountMenuState.open = false;
  },
  state: accountMenuState,
};

export default accountMenu;
